import { createApi } from '@/api/modules/utils'

const baseUrl = '/article_generation/personal/scene'
const api = createApi(baseUrl)

// 用户相关API
export const articleGenerationSceneApi = {
    default: api('default', 'post'),                              //默认场景
    find: api('find', 'get'),                                     //任务结果查询
    brandStory: api('brand_story', 'post'),                       //品牌故事
    casePromotion: api('case_promotion', 'post'),                 //案例推广
    companyIntroduction: api('company_introduction', 'post'),     //公司介绍
    evaluation: api('evaluation', 'post'),                        //测评/点评
    festivalActivities: api('festival_activities', 'post'),       //节日活动
    institutional: api('institutional', 'post'),                  //机构介绍
    judgmentRecommend: api('judgment_recommend', 'post'),         //判断推荐
    keywordQA: api('keyword_q_a', 'post'),                        //关键词问答
    productIntroduction: api('product_introduction', 'post'),     //产品介绍
    sciencePopularization: api('science_popularization', 'post'), //科普文章
    shopReviewArticle: api('shop_review_article', 'post'),        //探店文章
    travelPlan: api('travel_plan', 'post'),                       //旅游攻略

}